import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Partners from "./pages/partners";
import Events from "./pages/Events";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductsDetails from "./pages/Products-Details";
import ScrollToTopButton from "./components/ScrollToTopButton";
import PageLoader from "./components/PageLoader";

// 👇 Lazy load hook
const LazyLoadImages = () => {
  const location = useLocation();
  useEffect(() => {
    const images = document.querySelectorAll("img");
    images.forEach((img) => {
      if (!img.hasAttribute("loading")) {
        img.setAttribute("loading", "lazy");
      }
    });
  }, [location.pathname]);
  return null;
};

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleAllAssetsLoaded = async () => {
      // Wait for all <img> elements in the DOM to finish loading
      const images = Array.from(document.images);
      const imagePromises = images.map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      });

      // Wait until all are loaded
      await Promise.all(imagePromises);

      // Add a small delay for smoother transition (optional)
      setTimeout(() => setLoading(false), 500);
    };

    handleAllAssetsLoaded();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <Router>
      <LazyLoadImages />

      <Routes>
        <Route path="/" element={<Home />} /> 
        <Route path="/about" element={<About />} /> 
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/careers" element={<Careers />} /> 
        <Route path="/partners" element={<Partners />} />  
        <Route path="/events" element={<Events />} />       
        <Route path="/products" element={<Products />} /> 
        <Route path="/products/:categoryId" element={<ProductsDetails />} />       
      </Routes>

      <ScrollToTopButton />
    </Router>
  );
};

export default App;
